import React from 'react';
import { number, string } from 'prop-types';
import THEME from '../../constants/theme';

const NewCheck = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8047 3.52827C14.0651 3.78862 14.0651 4.21073 13.8047 4.47108L6.4714 11.8044C6.21106 12.0648 5.78894 12.0648 5.5286 11.8044L2.19526 8.47108C1.93491 8.21073 1.93491 7.78862 2.19526 7.52827C2.45561 7.26792 2.87772 7.26792 3.13807 7.52827L6 10.3902L12.8619 3.52827C13.1223 3.26792 13.5444 3.26792 13.8047 3.52827Z"
      fill={color}
    />
  </svg>
);

NewCheck.propTypes = {
  size: number,
  color: string,
};

NewCheck.defaultProps = {
  size: 16,
  color: THEME.primaryColors.white,
};

export default NewCheck;
